/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_date_range_picker__arrival_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Datum der Ankunft`
};

const en_date_range_picker__arrival_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Arrival date`
};

const es_date_range_picker__arrival_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Fecha de llegada`
};

const fr_date_range_picker__arrival_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Date d'arrivée`
};

const it_date_range_picker__arrival_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Data di arrivo`
};

const nl_date_range_picker__arrival_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Datum van aankomst`
};

const pt_date_range_picker__arrival_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Data de chegada`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__arrival_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.date_range_picker__arrival_placeholder(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("date_range_picker__arrival_placeholder", locale)
	if (locale === "de") return de_date_range_picker__arrival_placeholder(inputs)
	if (locale === "en") return en_date_range_picker__arrival_placeholder(inputs)
	if (locale === "es") return es_date_range_picker__arrival_placeholder(inputs)
	if (locale === "fr") return fr_date_range_picker__arrival_placeholder(inputs)
	if (locale === "it") return it_date_range_picker__arrival_placeholder(inputs)
	if (locale === "nl") return nl_date_range_picker__arrival_placeholder(inputs)
	return pt_date_range_picker__arrival_placeholder(inputs)
};